import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryGrid from './components/CategoryGrid';
import ArticleCards from './components/ArticleCards';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://acbuy.asia';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryGrid />
        <ArticleCards />
        <AboutSection />
        <TestimonialSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'AcBuy Spreadsheet',
            url: SITE_URL,
            description: 'Discover the latest AcBuy Spreadsheet updates, trusted shopping guides, QC tips, shipping advice, and the best curated finds for 2026. Browse 14 product categories with direct links and daily refreshed product lists.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${SITE_URL}/?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'AcBuy Spreadsheet',
            url: SITE_URL,
            description: 'Your trusted source for the best AcBuy Spreadsheet 2026 — curated product finds, shopping guides, QC tips, and shipping advice across 14 categories.',
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'AcBuy Spreadsheet 2026: Best Finds, Guides & Updated Links',
            url: SITE_URL,
            description: 'Discover the latest AcBuy Spreadsheet updates, trusted shopping guides, QC tips, shipping advice, and the best curated finds for 2026.',
            isPartOf: {
              '@type': 'WebSite',
              name: 'AcBuy Spreadsheet',
              url: SITE_URL,
            },
            about: {
              '@type': 'Thing',
              name: 'AcBuy Spreadsheet',
              description: 'A curated, daily-updated spreadsheet of the best fashion and lifestyle product finds across 14 categories.',
            },
          }),
        }}
      />
    </>
  );
}